import WindDirection from "../wind-direction/WindDirection";

import { forecastDataType } from "@/schemas/prevision-data-schema";
import { formatDatePrevisionTable } from "@/helpers/format-date";
import { formatWeatherStateIcon } from "@/helpers/format-weather-state-icon";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "@/hooks/use-window-resize";
import { PREVISION_LIST_TABLE_HEADER } from "./constants/prevision-list-constant";

import "./style.scss";

type PrevisionTableSmallProps = {
	data: forecastDataType[];
	showDate?: string;
};

export const PrevisionTableSmall = ({
	data,
	showDate,
}: PrevisionTableSmallProps) => {
	const width = useWindowSize();
	const { t } = useTranslation();
	const now = new Date();

	const currentHourDate = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		now.getHours(),
		0,
		0,
		0,
	);

	currentHourDate.setHours(currentHourDate.getHours() - 3);

	return (
		<table className="prevision-table-small">
			<thead>
				<tr>
					{PREVISION_LIST_TABLE_HEADER.map((item) => {
						const { icon, key } = item;
						const textTranslate = t(key);

						return (
							<th key={key}>
								{width > 650 ? (
									textTranslate
								) : icon ? (
									<img src={icon} alt={textTranslate} />
								) : (
									textTranslate
								)}
							</th>
						);
					})}
				</tr>
			</thead>

			<tbody>
				{showDate && (
					<tr className="date-row">
						<td colSpan={6}>{showDate}</td>
					</tr>
				)}

				{data.length > 0 ? (
					data.map((row, index) => {
						const icon =
							row.ww !== undefined
								? formatWeatherStateIcon({
										status: row.ww,
										timeStep: row.timestep,
								  })
								: undefined;

						return (
							<tr
								key={index}
								className={`${
									new Date(row.timestep) >= currentHourDate ? null : "past"
								}`}
							>
								<td>{formatDatePrevisionTable(row.timestep)}</td>

								<td>{icon ? <img src={icon} alt="weather-icon" /> : "-"}</td>

								<td>{row.temperature_2m ?? "-"}</td>
								<td>{row.precipitation_accumulation_3h ?? "-"}</td>

								<td>
									{row.wind_direction_10m != undefined ? (
										<WindDirection
											color="var(--wp--preset--color--text-primary)"
											rotation={row.wind_direction_10m}
										/>
									) : (
										"-"
									)}
								</td>

								<td>{row.wind_speed_10m ?? "-"}</td>
							</tr>
						);
					})
				) : (
					<tr className="empty-data">
						<td colSpan={10}>No data to display</td>
					</tr>
				)}
			</tbody>
		</table>
	);
};

export default PrevisionTableSmall;
